<template>
  <section class="section" id="bags-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <!-- @get-operators="getOperators" -->
      <bags-title @add-bag="addBag" @get-bags="getBags" />

      <bags-table
        :bags="bags"
        @edit-bag="editBag"
        @qrcode-click="openQRCodeModal"
        @delete-bag="deleteBagModal"
      />
    </div>

    <b-modal :active.sync="isBagModelActive">
      <bag-modal
        :bagBeingEdited="bagBeingEdited"
        @on-bag-updated="onBagUpdated"
        @on-bag-added="getBags"
        @on-products-updated="onProductsUpdated"
        :maxInstallments="3"
      />
      <!-- @get-operators="getOperators" -->
    </b-modal>

    <b-modal :active.sync="isQRCodeModalActive">
      <qrcode-modal :qrcode="qrcode" />
    </b-modal>

    <b-modal :active.sync="isDeleteBagModalOpen">
      <delete-bag-modal
        :storeId="storeBeingManaged._id"
        :bag="bagBeingDeleted"
        @on-bag-deleted="onBagDeleted"
      />
    </b-modal>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import bagsTitle from "./BagsTitle";
import bagsTable from "./BagsTable";
import bagModal from "./BagModal";
import qrcodeModal from "./QRCodeModal.vue";
import deleteBagModal from "./DeleteBagModal.vue";

export default {
  mixins: [common],

  components: {
    bagsTitle,
    bagsTable,
    bagModal,
    qrcodeModal,
    deleteBagModal
  },

  data() {
    return {
      isLoading: false,
      isBagModelActive: false,
      bagBeingEdited: {},
      isQRCodeModalActive: false,
      qrcode: "",
      isDeleteBagModalOpen: false,
      bagBeingDeleted: {}
    };
  },

  methods: {
    addBag() {
      this.bagBeingEdited = {};
      this.isBagModelActive = true;
    },

    editBag(bag) {
      this.bagBeingEdited = JSON.parse(JSON.stringify(bag));
      this.isBagModelActive = true;
    },

    getBags() {
      this.isLoading = true;
      this.$store
        .dispatch("getBags", { storeId: this.storeBeingManaged._id })
        .then(res => {
          if (res.data.result === "ok") {
            this.storeBeingManaged.bags = res.data.payload.bags;
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onBagUpdated(bag) {
      let selectedBag = this.storeBeingManaged.bags.find(
        b => b._id === bag._id
      );
      if (selectedBag) {
        selectedBag.maxInstallments = bag.maxInstallments;
        selectedBag.name = bag.name;
        selectedBag.terminal = bag.terminal;
      }
    },

    onProductsUpdated(products) {
      let bag = this.bags.find(b => b._id === this.bagBeingEdited._id);
      if (bag) bag.prdQty = products.length;
    },

    openQRCodeModal(bagUUID) {
      // TODO: verificar como tratar gou para MQ
      this.qrcode = `https://gou.onii.app?s=${this.storeBeingManaged.uuid}&b=${bagUUID}`;
      this.isQRCodeModalActive = true;
    },

    deleteBagModal(bag) {
      this.bagBeingDeleted = bag;
      this.isDeleteBagModalOpen = true;
    },

    onBagDeleted(bag) {
      const index = this.bags.findIndex(b => b._id === bag._id);
      if (index >= 0) this.bags.splice(index, 1);
    }
  },

  computed: {
    ...mapGetters(["storeBeingManaged"]),
    bags() {
      return this.storeBeingManaged.bags;
    }
  },

  mounted() {
    //this.getOperators();
  }
};
</script>

<style scoped>
#bags-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
